import { Injectable } from '@angular/core'
import { ShopsService } from '../../shops.service'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { ShopUsersStateModel } from './shop-users.model'
import { GetShopPendingUsers, GetShopUsers, UpdateUserShopAccess } from './shop-users.actions'

@State<ShopUsersStateModel>({
  name: 'shopUsers'
})
@Injectable()
export class ShopUsersState {
  constructor(private shopsService: ShopsService) {}

  @Selector()
  static users(state: ShopUsersStateModel) {
    return state.users
  }

  @Action(GetShopUsers)
  getShopUsers(ctx: StateContext<ShopUsersStateModel>, { shopId }: GetShopUsers) {
    return this.shopsService.getShopUsers(shopId).pipe(
      tap((res) => {
        ctx.patchState({ users: res?.users })
      })
    )
  }

  @Action(GetShopPendingUsers)
  getShopPendingUsers(ctx: StateContext<ShopUsersStateModel>, { shopId }: GetShopPendingUsers) {
    return this.shopsService.getShopPendingUsers(shopId).pipe(
      tap((res) => {
        ctx.patchState({ users: res?.users })
      })
    )
  }

  @Action(UpdateUserShopAccess)
  updateUserShopAccess(ctx: StateContext<ShopUsersStateModel>, { payload }: UpdateUserShopAccess) {
    return this.shopsService.updateUserShopAccess(payload)
  }
}
